import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Link from "./link"
import { htmlDecode } from "../Utils"

const FeaturedItemsBlock = ({
  key,
  title=null,
  subText=null
}) => {
  const queryData = useStaticQuery(graphql`
    query {
      allStrapiResource(limit: 4) {
        edges {
          node {
            title
            customerVideoContent
            slug
            featuredImage {
              alternativeText
              url
              formats {
                medium {
                  url
                }
              }
            }
            resource_categories {
              name
            }
          }
        }
      }
      allStrapiPost(limit: 4) {
        edges {
          node {
            title
            content
            slug
            featuredImage {
              alternativeText
              url
              formats {
                medium {
                  url
                }
              }
            }
            categories {
              name
            }
          }
        }
      }
      allStrapiNews(limit: 4) {
        edges {
          node {
            title
            content
            slug
            featuredImage {
              alternativeText
              url
              formats {
                medium {
                  url
                }
              }
            }
            news_category {
              name
            }
          }
        }
      }
    }
  `)
  const featuredItems = []
  const resources = queryData.allStrapiResource.edges
  const posts = queryData.allStrapiPost.edges
  const news = queryData.allStrapiNews.edges
  for (let i = 0; i < resources.length; i++) featuredItems.push(resources[i].node)
  for (let i = 0; i < posts.length; i++) featuredItems.push(posts[i].node)
  for (let i = 0; i < news.length; i++) featuredItems.push(news[i].node)

  return (
    <div className="feature-set-block bgw">
      <div className="container">
        <div className="row">
          <div className="col dif aic">
            <div className="col-12 col-md-8 offset-md-1 text-center">
              {title &&
                <h2 className="content-title center orange-dash">{ htmlDecode(title) }</h2>
              }
              {subText &&
                <div className="section-content" dangerouslySetInnerHTML={{ __html: subText }} />
              }
            </div>
          </div>
        </div>
        <div className="row jcc mt2">
          {featuredItems && featuredItems.map((item, index) => (
            <div className="col-md-4 col-xl-4 list-item ph2">
              <div className="list-content bgw br3 ofh bs1">
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FeaturedItemsBlock
